// ** Type Import
import { OwnerStateThemeType } from "../";

const IconButton = () => {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: ({ ownerState, theme }: OwnerStateThemeType) => ({}),
      },
    },
  };
};

export default IconButton;
